import React from 'react';
import { Route } from 'react-router-dom';
import PatientAdmission from '../components/inpatient/PatientAdmission';
import PatientDischarge from '../components/inpatient/PatientDischarge';
import PatientTransfer from '../components/inpatient/PatientTransfer';
import NursingFlowsheet from '../components/inpatient/NursingFlowsheet';
import InpatientList from '../components/inpatient/InpatientList';
import BedAssignmentPage from '../components/inpatient/BedAssignmentPage';

export const inpatientRoutes = [
    <Route key="admit-patient" path="/inpatient/admit" element={<PatientAdmission />} />,
    <Route key="discharge-patient" path="/inpatient/discharge" element={<PatientDischarge />} />,
    <Route key="transfer-patient" path="/inpatient/transfer" element={<PatientTransfer />} />,
    <Route key="bed-assignment" path="/inpatient/bed-assignment" element={<BedAssignmentPage />} />,
    <Route key="nursing-flowsheet" path="/inpatient/flowsheet" element={<NursingFlowsheet />} />,
    <Route key="inpatient-list" path="/inpatient/list" element={<InpatientList />} />
]; 